import React, { useContext, useState }  from 'react';

import Header from './components/svg/Header';
import Component0 from './components/Component0';
import Component1 from './components/Component1';
import Component2 from './components/Component2';
import Component3 from './components/Component3';
import { Column, Row } from "simple-flexbox";

import { ComponentContext, ComponentProvider } from './contexts/ComponentContext';
import './App.scss';




const App = (props) => {
    // const [id, setId] = useState(1);
    
   const [component, setComponent] = useContext(ComponentContext);
    const styleRep = {
        backgroundImage: 'url('+process.env.REACT_APP_API_URL+'/img/elements/indic.svg)',
    };
    const styleActive = {
        backgroundImage: 'url('+process.env.REACT_APP_API_URL+'/img/elements/indic_active.svg)',  
    }
    const title = (component.id === 1 ? '2030':'2050');

    const LoadComponent = (props) => {
        switch(props.active) {
            case 0: {
                return <Component0 />
            }
            case 1: {
                return <Component1 />
            }
            case 2: {
                return <Component2 />
            }
            case 3: {
                return <Component3 />
            }
            default: {
                return <Component1 />
            }
        }
    }

    return ( 
        <>
            <h2>Nos objectifs <b>{ title }</b></h2>
            <Header />
            <section>
                <LoadComponent active ={component.id} /> 
            </section>
        </>
    );
}

export default App;
